import { send } from '../adapters/OneDMP';
import ClickstreamProtocol from './ClickstreamProtocol';
import { DMPEVENT, Packet } from '@/app/modules/Metrics/loaders/OneDMP';
import CSCToDMPCloneStruct from '../CSCToDMPCloneStruct';

export default class OneDMPProtocol extends ClickstreamProtocol {
    /**
     * @param value
     */
    protected prepareDMPData(value: CSCToDMPCloneStruct | DMPEVENT): Packet {
        if (value instanceof CSCToDMPCloneStruct) {
            delete value.divolte.rewriteParameters;

            return {
                event: value.dmpType,
                data: this.prepareCSCData(value.divolte),
            };
        } else {
            return {
                event: value,
                data: undefined,
            };
        }
    }

    public send() {
        send(this.prepareDMPData(this.value));
    }
}
